import { useEffect, useState } from 'react'
import { useInstallPrompt } from '../hooks/useInstallPrompt'

export function PWAIOSHint() {
  const { isIOS, dismissPrompt } = useInstallPrompt()
  const [showHint, setShowHint] = useState(false)

  useEffect(() => {
    if (!isIOS) return
    // Wait 15s before showing — don't be pushy on first interaction.
    const timer = setTimeout(() => setShowHint(true), 15000)
    return () => clearTimeout(timer)
  }, [isIOS])

  if (!isIOS || !showHint) return null

  return (
    <div className="pwa-ios-hint" role="dialog" aria-label="Install Aspired AI">
      <button
        className="pwa-ios-hint-close"
        onClick={() => {
          setShowHint(false)
          dismissPrompt()
        }}
        aria-label="Dismiss"
      >
        ×
      </button>
      <div className="pwa-ios-hint-content">
        <strong>📱 Install Aspired AI</strong>
        <p>For the full app experience:</p>
        <ol className="pwa-ios-hint-steps">
          <li>Tap <strong>Share</strong></li>
          <li>Tap <strong>View More</strong></li>
          <li>Tap <strong>Add to Home Screen</strong></li>
        </ol>
      </div>
    </div>
  )
}
